import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ErrorLogModal({ show, handleClose, log }) {
  const { t } = useTranslation('common');

  return (
    <Modal className="custom-modal modal-md" show={show}>
      <Modal.Header>
        <Modal.Title>{t('CARE_LABELS.ERROR_LOG_MODAL.EXCEL_IMPORT_MODAL')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('CARE_LABELS.ERROR_LOG_MODAL.EXCEL_IMPORT_UNSUCCESSFUL')}</p>
        <p>{t('CARE_LABELS.ERROR_LOG_MODAL.REASON_RESULT')}</p>
        <ul>
          {log.map((eleItem) => {
            return (
              <li key={eleItem.code}>
                <p>
                  <b>{eleItem.code}</b> : {eleItem?.message}
                </p>
              </li>
            );
          })}
        </ul>
        <div className="text-center">
          <button onClick={handleClose} type="button" className="btn btn-default">
            {t('CARE_LABELS.ERROR_LOG_MODAL.OK')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ErrorLogModal;
